import React, { FunctionComponent, useMemo, useRef, useState } from "react"
import { useHistory } from "react-router"
import { iBasicQuery } from "../../definitions/interfaces"
import s from "./Pagination.less"

interface iProps {
  setQuery?: (query: iBasicQuery) => void
  total: number
  limit: number
  elementCount?: number
}

const Pagination: FunctionComponent<iProps> = ({ total, limit, setQuery }) => {
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(
    new URLSearchParams(history.location.search).get("page") || "1",
  )
  const _page = useRef(
    new URLSearchParams(history.location.search).get("page") || "1",
  )

  const totalPages = useRef(Math.ceil(total / limit))

  useMemo(() => {
    const query = new URLSearchParams(history.location.search)
    const page = query.get("page") || "1"
    if (currentPage !== page) {
      setCurrentPage(page)
      _page.current = page
    }
  }, [history.location.search])

  useMemo(() => {
    totalPages.current = Math.ceil(total / limit)
  }, [total])

  const firstPage = () => {
    const page = parseInt(currentPage)
    if (page > 1) {
      setCurrentPage("1")
      _page.current = "1"
      setQuery && setQuery({ page: 1 })
    }
  }

  const previousPage = () => {
    const page = parseInt(currentPage)
    if (page > 1) {
      const str = (page - 1).toString()
      setCurrentPage(str)
      _page.current = str
      setQuery && setQuery({ page: page - 1 })
    }
  }

  const nextPage = () => {
    const page = parseInt(currentPage)
    if (page < totalPages.current) {
      const str = (page + 1).toString()
      setCurrentPage(str)
      _page.current = str
      setQuery && setQuery({ page: page + 1 })
    }
  }
  const lastPage = () => {
    const page = parseInt(currentPage)
    if (page < totalPages.current) {
      const str = totalPages.current.toString()
      setCurrentPage(str)
      _page.current = str
      setQuery && setQuery({ page: totalPages.current })
    }
  }

  const handleBlur = () => {
    const page = parseInt(currentPage)
    if (page < 1) {
      setCurrentPage("1")
      if (_page.current !== "1") {
        setQuery && setQuery({ page: 1 })
      }
    } else if (page > totalPages.current) {
      const str = totalPages.current.toString()
      setCurrentPage(str)
      if (_page.current !== str) {
        setQuery && setQuery({ page: totalPages.current })
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPage(e.target.value)
    const page = parseInt(e.target.value)
    if (!isNaN(page) && page <= totalPages.current && page >= 1) {
      _page.current = page.toString()
      setQuery && setQuery({ page })
    }
  }

  return totalPages.current > 1 ? (
    <div className={s.paginationWrap}>
      <div className={s.pagination}>
        <ul>
          <li onClick={previousPage}>
            <div
              className={`${s.number} ${
                parseInt(currentPage) === 1 ? s.disabled : ""
              }`}
            >
              <i className="fa fa-chevron-left"></i>
            </div>
          </li>
          <li onClick={firstPage}>
            <div
              className={`${s.number} ${
                parseInt(currentPage) === 1 ? s.disabled : ""
              }`}
            >
              <i>1</i>
            </div>
          </li>
          <li>
            <div className={s.numberField}>
              <input
                type="number"
                onBlur={handleBlur}
                onChange={handleChange}
                value={currentPage}
              />
            </div>
          </li>
          <li onClick={lastPage}>
            <div
              className={`${s.number} ${
                totalPages.current === parseInt(currentPage) ? s.disabled : ""
              }`}
            >
              <i>{totalPages.current}</i>
            </div>
          </li>
          <li onClick={nextPage}>
            <div
              className={`${s.number} ${
                totalPages.current === parseInt(currentPage) ? s.disabled : ""
              }`}
            >
              <i className="fa fa-chevron-right"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
  ) : null
}

export default Pagination
